<template>
  <div style="background-color: #fff; font-size: 14px; height:100vh">
    <div class="title">管理员提醒你：你在 <span>{{groupdata.sendTime}}</span> 给以下群发送消息</div>
    <div class="group">
      <div class="group_title">
        <div class="shu"></div>
        <div>群:({{groupdata.groupRspList.length}})</div>
      </div>
      <div class="conte" v-for="(item,index) in groupdata.groupRspList" :key="index">
        <div style="display: flex">
          <img src="../../assets/images/qltb.svg" alt="" />
          <div style="margin-left: 8px">
            <div>群名称:{{item.groupName}}</div>
            <div style="font-size: 12px; color: #999; margin-top: 6px">
              群主:{{item.ownAccountName}}
            </div>
          </div>
        </div>
        <div class="copy" v-clipboard:copy='[item.groupName]' v-clipboard:success="onCopy">复制</div>
      </div>
      <div class="conte_xt">
        <div style="display: flex">
            <div class="shu"></div>
            <div>内容：
                
            </div>
        </div>
        <div class="copy" v-clipboard:copy='[groupdata.content]' v-clipboard:success="onCopy">复制</div>
      </div>
      <div class="xt">
          <div class="xt_title" v-if="groupdata.title">{{groupdata.title}}</div>
          <div v-if="groupdata.sendType===1" style="margin-top:15px">
            <img :src="groupdata.content" alt="" style="width:100%">
          </div>
          <div v-else style="margin-top:15px">
            {{groupdata.content}}
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {timeFormat} from '../../utils/index'
export default {
  data() {
    return {
      groupdata:{},
    }
  },
  props: {
    href: {
      type: Object,
      default: null
    }
  },
  mounted(){
    this.Member()
  },
  methods:{
      Member(){
          this.$http.get('/scrm/v1/wxcp-calendar-detail/p/findByIdAndMemberId',{
            params:{
              memberId:this.href.memberId,
              tenancyId:this.href.tenancyId,
              id:this.href.id
            }
          }).then(res=>{
            if(res.code===1){
               this.groupdata=res.data
               if(this.groupdata){
                  this.groupdata.sendTime=timeFormat(this.groupdata.sendTime,'yyyy-MM-dd hh:mm')
               }
            }
          })
      },
      onCopy(e){
        this.$toast.success("内容已复制到剪切板！")
      }
    },
}
</script>
 
<style lang = "less" scoped>
.shu {
    width: 2px;
    height: 14px;
    background-color: #4983f5;
    margin-right: 3px;
}
.title {
  height: 60px;
  width: 100%;
  background-color: #f0f8ff;
  text-align: center;
  line-height: 60px;
  color: #333333;
  span {
    color: #1354d3;
    text-decoration: underline;
  }
}
.group {
  padding: 16px 16px 0 16px;
  .group_title {
    display: flex;
    
  }
  .conte {
    padding: 18px 0;
    border-bottom: 1px solid #f3f3f3;
    display: flex;
    justify-content: space-between;
    img {
      display: block;
      width: 32px;
      height: 32px;
    }
  }
  .copy {
      width: 59px;
      height: 29px;
      background: #e6f5ff;
      border-radius: 4px;
      text-align: center;
      line-height: 29px;
    }
  .conte_xt{
    padding: 18px 0 6px 0;
    display: flex;
    justify-content: space-between;
  }
  .xt{
      width: 100%;
      min-height: 275px;
      background: #F6F6F6;
      padding: 10px 0 0 0;
      .xt_title{
        text-align: center;
      }
    }
}
</style>